import React, { useEffect, useState } from "react";
import DashboardMUI from "../dashboard/DashboardMui";
import AppointmentSummary from "../widgets/AppointmentSummary";
import Loading from "../utils/Loading";
import { resizeByLink } from "../utils/ResizeLinkCloudinary";
import { canJoinVirtualAppointment } from "../utils/AppointmentUtils";
import lineChart from "../../images/line-chart.svg";
import moment from "moment";

import AppointmentHistory from "../widgets/AppointmentHistory";
import SandClockIcon from "../../images/hourglass.svg";
import useUserState from "../hooks/useUserState";
import useBDocTranslator from "../hooks/useBDocTranslator";
import Axios from "axios";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import {
  useAppointmentsHistoryByProvider,
  useGetProviderById,
} from "../../services/services";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Avatar,
  Chip,
  IconButton,
  Paper,
  Divider,
  LinearProgress,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  Badge,
  Tooltip,
  Collapse,
  TextField,
  Button,
  Alert,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import PeopleIcon from "@material-ui/icons/People";
import EventIcon from "@material-ui/icons/Event";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import StarIcon from "@material-ui/icons/Star";
import ScheduleIcon from "@material-ui/icons/Schedule";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import VideoCallIcon from "@material-ui/icons/VideoCall";
import BusinessIcon from "@material-ui/icons/Business";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import PersonIcon from "@material-ui/icons/Person";
import PaymentIcon from "@material-ui/icons/Payment";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import EventBusyIcon from "@material-ui/icons/EventBusy";
import TouchAppIcon from "@material-ui/icons/TouchApp";
import OfflinePinIcon from "@material-ui/icons/OfflinePin";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import EditIcon from "@material-ui/icons/Edit";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
    maxWidth: "none",
  },
  statsGrid: {
    marginBottom: theme.spacing(3),
  },
  statCard: {
    borderRadius: theme.spacing(2),
    background: "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    transition: "all 0.3s ease",
    border: "1px solid rgba(0, 0, 0, 0.05)",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 20px rgba(0, 0, 0, 0.12)",
    },
  },
  statContent: {
    padding: theme.spacing(2.5),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  statIcon: {
    width: 48,
    height: 48,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
  },
  statInfo: {
    flex: 1,
    marginLeft: theme.spacing(2),
  },
  statValue: {
    fontSize: "1.8rem",
    fontWeight: 700,
    color: "#2c3e50",
    lineHeight: 1,
  },
  statLabel: {
    fontSize: "0.9rem",
    color: "#6c757d",
    fontWeight: 500,
    marginTop: theme.spacing(0.5),
  },
  sectionCard: {
    borderRadius: theme.spacing(2),
    background: "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    border: "1px solid rgba(0, 0, 0, 0.05)",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  sectionHeader: {
    padding: theme.spacing(2.5, 2.5, 1, 2.5),
    borderBottom: "1px solid rgba(0, 0, 0, 0.05)",
  },
  sectionTitle: {
    fontWeight: 600,
    color: "#2c3e50",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  sectionContent: {
    flex: 1,
    padding: theme.spacing(1.5),
    maxHeight: "500px",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#c1c1c1",
      borderRadius: "3px",
      "&:hover": {
        background: "#a8a8a8",
      },
    },
  },
  noDataContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
    color: "#6c757d",
  },
  noDataIcon: {
    width: 80,
    height: 80,
    marginBottom: theme.spacing(2),
    opacity: 0.5,
  },
  progressContainer: {
    marginTop: theme.spacing(1),
  },
  ratingContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },
  // New styles for professional appointment cards
  appointmentCard: {
    marginBottom: theme.spacing(2),
    borderRadius: theme.spacing(1.5),
    border: "1px solid #e0e0e0",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 25px rgba(0, 0, 0, 0.12)",
      borderColor: theme.palette.primary.main,
    },
  },
  appointmentHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1),
  },
  patientInfo: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  patientAvatar: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    border: "2px solid #fff",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
  },
  patientDetails: {
    flex: 1,
  },
  patientName: {
    fontWeight: 600,
    color: "#2c3e50",
    fontSize: "1rem",
  },
  appointmentTime: {
    color: "#7f8c8d",
    fontSize: "0.875rem",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    marginTop: theme.spacing(0.5),
  },
  appointmentMeta: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1.5),
    flexWrap: "wrap",
  },
  statusChip: {
    fontSize: "0.75rem",
    height: 24,
    fontWeight: 500,
  },
  typeChip: {
    fontSize: "0.75rem",
    height: 24,
    fontWeight: 500,
    backgroundColor: "#e3f2fd",
    color: "#1976d2",
  },
  paymentChip: {
    fontSize: "0.75rem",
    height: 24,
    fontWeight: 500,
  },
  appointmentActions: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  sectionHeaderEnhanced: {
    padding: theme.spacing(2.5),
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
    background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  sectionTitleEnhanced: {
    fontWeight: 600,
    color: "#2c3e50",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    fontSize: "1.1rem",
  },
  sectionCount: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    fontSize: "0.75rem",
    fontWeight: 600,
    minWidth: 20,
    height: 20,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: theme.spacing(1),
  },
  emptyState: {
    textAlign: "center",
    padding: theme.spacing(6, 2),
    color: "#7f8c8d",
  },
  emptyStateIcon: {
    fontSize: 64,
    color: "#bdc3c7",
    marginBottom: theme.spacing(2),
  },
  emptyStateText: {
    fontSize: "1.1rem",
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  emptyStateSubtext: {
    fontSize: "0.9rem",
    color: "#95a5a6",
  },
  // Expandable appointment management styles
  expandablePanel: {
    backgroundColor: "#f8f9fa",
    borderTop: "1px solid #e0e0e0",
    padding: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  actionButtonsContainer: {
    display: "flex",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
    flexWrap: "wrap",
  },
  actionButton: {
    minWidth: 100,
    fontSize: "0.75rem",
    height: 32,
  },
  confirmButton: {
    backgroundColor: "#4caf50",
    color: "white",
    "&:hover": {
      backgroundColor: "#45a049",
    },
  },
  cancelButton: {
    backgroundColor: "#f44336",
    color: "white",
    "&:hover": {
      backgroundColor: "#da190b",
    },
  },
  completeButton: {
    backgroundColor: "#17a2b8",
    color: "white",
    "&:hover": {
      backgroundColor: "#138496",
    },
  },
  reminderButton: {
    backgroundColor: "#3d73c3",
    color: "white",
    "&:hover": {
      backgroundColor: "#2c5aa0",
    },
  },
  formSection: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: "white",
    borderRadius: theme.spacing(1),
    border: "1px solid #e0e0e0",
  },
  formRow: {
    display: "flex",
    gap: theme.spacing(2),
    alignItems: "flex-end",
    marginBottom: theme.spacing(2),
  },
  expandButton: {
    transition: "transform 0.3s ease",
    "&.expanded": {
      transform: "rotate(180deg)",
    },
  },
  appointmentReason: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1.5),
    backgroundColor: "#f8f9fa",
    borderRadius: theme.spacing(1),
    border: "1px solid #e9ecef",
    borderLeft: "4px solid #1976d2",
  },
}));

function MainProviders() {
  const classes = useStyles();
  const localState = useUserState();
  const providerId = localState[0]?.extendedData?.id;
  const jwt = localState[0]?.jwt;
  const history = useHistory();
  const [providerStats, setProviderStats] = useState({
    totalPatients: 0,
    totalAppointments: 0,
    totalIncome: 0,
    averageRating: 0,
    completedAppointments: 0,
    virtualAppointments: 0,
  });
  const [loadingStats, setLoadingStats] = useState(true);

  // Appointment management states
  const [expandedAppointment, setExpandedAppointment] = useState(null);
  const [newPrice, setNewPrice] = useState("");
  const [rescheduleDate, setRescheduleDate] = useState("");
  const [actionLoading, setActionLoading] = useState(false);

  const {
    getProviderById,
    loading: loadingData,
    providerData: appointments,
  } = useGetProviderById(providerId, jwt);
  const {
    getAppointmentsHistoryByProvider,
    appointmentsHistory: bookingHistory,
  } = useAppointmentsHistoryByProvider(providerId, jwt);
  const { t, changeDirectLanguage } = useBDocTranslator();

  // Fetch provider statistics
  const fetchProviderStats = async () => {
    if (!providerId || !jwt) return;
    setLoadingStats(true);
    try {
      const endDate = moment().format("YYYY-MM-DD");
      const startDate = moment().subtract(30, "days").format("YYYY-MM-DD");

      // Totales locales desde las citas ya cargadas
      const localAppointments = appointments || [];
      const totalPatients = new Set(
        localAppointments.map((a) => a.patient?.id).filter(Boolean)
      ).size;

      // Ingreso (independiente — fallback 0 si falla)
      let totalIncome = 0;
      try {
        const incomeResponse = await Axios.get(
          `${process.env.REACT_APP_API_URL_BASE}/reports/appointments/income`,
          {
            params: { startDate, endDate, providerId },
            headers: { Authorization: "Bearer " + jwt },
          }
        );
        totalIncome = (incomeResponse.data || []).reduce(
          (sum, day) => sum + (parseFloat(day.totalIncome) || 0),
          0
        );
      } catch (error) {
        console.error("Error fetching provider income:", error);
      }

      // Rating (independiente — fallback 0 si falla)
      let averageRating = 0;
      try {
        const providerResponse = await Axios.get(
          `${process.env.REACT_APP_API_URL_BASE}/provider/review/${providerId}`,
          {
            headers: { Authorization: "Bearer " + jwt },
          }
        );
        averageRating = providerResponse.data?.rating_avg || 0;
      } catch (error) {
        console.error("Error fetching provider rating:", error);
      }

      setProviderStats({
        totalPatients,
        totalAppointments: localAppointments.length,
        totalIncome,
        averageRating,
        completedAppointments: localAppointments.filter(
          (a) => a.status_appointment?.appt_status_code === "CDAPPT"
        ).length,
        virtualAppointments: localAppointments.filter(
          (a) => a.event_type === "VIRTUAL"
        ).length,
      });
    } finally {
      setLoadingStats(false);
    }
  };

  useEffect(() => {
    changeDirectLanguage();
    getProviderById(providerId);
    getAppointmentsHistoryByProvider(providerId);
    fetchProviderStats();
  }, [providerId]);

  // Appointment management functions
  const handleExpandAppointment = (appointmentId) => {
    setExpandedAppointment(
      expandedAppointment === appointmentId ? null : appointmentId
    );
    setNewPrice("");
    setRescheduleDate("");
  };

  const handleChangeStatus = async (appointmentId, newStatus, patientName) => {
    try {
      setActionLoading(true);
      await Axios.put(
        `${process.env.REACT_APP_API_URL_BASE}/appointments/updateStatus`,
        {
          id: appointmentId,
          appt_status_code: newStatus,
          providerName: `${localState[0]?.extendedData?.firstName} ${localState[0]?.extendedData?.lastname}`,
          patientName,
        },
        {
          headers: {
            Authorization: "Bearer " + jwt,
          },
        }
      );

      swal(t("Success!"), t("Appointment status Changed"), "success");
      // Refresh appointments
      getProviderById(providerId);
    } catch (error) {
      swal(
        "Error!",
        t("Something went wrong, please contact the Admin ") + error,
        "error"
      );
    } finally {
      setActionLoading(false);
    }
  };

  const handleUpdatePrice = async (appointmentId, orderId) => {
    if (!newPrice) {
      swal("Error!", t("Please type New price"), "error");
      return;
    }

    try {
      setActionLoading(true);
      await Axios.put(
        `${process.env.REACT_APP_API_URL_BASE}/services/updatePrice`,
        {
          appointment_id: appointmentId,
          price_total: newPrice,
          orderId: orderId,
        },
        {
          headers: {
            Authorization: "Bearer " + jwt,
          },
        }
      );

      swal(
        t("Success!"),
        t("Price For this Appointment was Changed"),
        "success"
      );
      setNewPrice("");
      // Refresh appointments
      getProviderById(providerId);
    } catch (error) {
      swal(
        "Error!",
        t("Something went wrong, please contact the Admin ") + error,
        "error"
      );
    } finally {
      setActionLoading(false);
    }
  };

  const handlePaymentReminder = async (
    appointmentId,
    orderId,
    paymentStatus
  ) => {
    if (paymentStatus?.toUpperCase() === "COMPLETED") {
      swal(
        "Error!",
        t("Appointment was payed by the Patient, cannot send an reminder"),
        "warning"
      );
      return;
    }

    try {
      setActionLoading(true);
      await Axios.post(
        `${process.env.REACT_APP_API_URL_BASE}/payments/requestPay`,
        {
          appointment_id: appointmentId,
          orderId: orderId,
        },
        {
          headers: { Authorization: "Bearer " + jwt },
        }
      );

      swal(t("Success!"), t("Reminder Sent to the Patient"), "success");
    } catch (error) {
      swal(
        "Error!",
        t(
          "Something's Wrong Retrieving the Appointment details, please contact Support"
        ),
        "warning"
      );
    } finally {
      setActionLoading(false);
    }
  };

  const handleReschedule = async (appointmentId, appointment) => {
    if (!rescheduleDate) {
      swal("Warning", t("Please select a different Date"), "warning");
      return;
    }

    try {
      setActionLoading(true);

      // Get service duration from appointment data, fallback to 15 minutes
      const serviceDuration =
        appointment?.services_orders?.[0]?.service_type?.duration_minute || 15;

      // Handle timezone properly: treat rescheduleDate as UTC to avoid timezone conversion
      const startDateUTC = rescheduleDate + ":00.000Z"; // Convert to UTC format
      const startDate = new Date(startDateUTC);
      const endDate = new Date(startDate.getTime() + serviceDuration * 60000);

      await Axios.put(
        `${process.env.REACT_APP_API_URL_BASE}/appointments/updateAppointment`,
        {
          id: appointmentId,
          appt_date_start: startDateUTC,
          appt_date_end: endDate.toISOString(),
          appt_status_code: "CAPPT",
        },
        {
          headers: {
            Authorization: "Bearer " + jwt,
          },
        }
      );

      swal(t("Success!"), t("Appointment Re-scheduled"), "success");
      setRescheduleDate("");
      // Refresh appointments
      getProviderById(providerId);
    } catch (error) {
      swal(
        "Error!",
        t("Something went wrong, please contact the Admin ") + error,
        "error"
      );
    } finally {
      setActionLoading(false);
    }
  };

  // Function to handle joining virtual appointment
  const handleJoinVirtualAppointment = (appointment) => {
    const providerFullname = `${localState[0]?.extendedData?.firstName} ${localState[0]?.extendedData?.lastname}`;

    // Navigate to provider lobby with required state
    history.push({
      pathname: "/admin/provider/lobby",
      state: {
        event_code: appointment.event_code,
        providerFullname,
        password: appointment.id, // Using appointment ID as password
        appointmentId: appointment.id,
        patientId: appointment.patient?.id,
      },
    });
  };

  // Function to check if provider can join virtual appointment
  // Modified to allow joining if appointment is confirmed, regardless of other validations
  const canJoinVirtualAppointmentLocal = (appointment, paymentStatus) => {
    // Validate required parameters
    if (!appointment) {
      return false;
    }

    // First check if appointment is virtual (keeping this validation)
    const isVirtual = appointment?.event_type === "VIRTUAL";
    if (!isVirtual) {
      return false;
    }

    // Check if appointment is confirmed (status code "CAPPT" or description "confirmed")
    const isConfirmed =
      appointment?.status_appointment?.code === "CAPPT" ||
      appointment?.status_appointment?.description?.toLowerCase() ===
        "confirmed";

    // For providers: allow joining if appointment is confirmed, regardless of payment status
    if (isConfirmed) {
      return true;
    }

    // Original payment validation logic (commented out for provider use case)
    /*
    // Priority-based validation: free appointments first, then paid confirmed appointments
    const appointmentPrice = appointment?.services_orders?.[0]?.service_type?.price || 0;
    const isFreeAppointment = parseFloat(appointmentPrice) === 0;
    
    // If appointment is free, allow join immediately (just need to be virtual and confirmed)
    if (isFreeAppointment) {
      return true;
    }
    
    // If appointment has a price, check payment status
    const normalizedPaymentStatus = (paymentStatus || '').toString().toUpperCase();
    const isPaid = normalizedPaymentStatus === "COMPLETED";
    
    return isPaid;
    */

    // For now, return false if not confirmed
    return false;
  };

  const NoData = ({ message, icon, subtitle }) => {
    return (
      <Box className={classes.emptyState}>
        {icon || <ScheduleIcon className={classes.emptyStateIcon} />}
        <Typography className={classes.emptyStateText}>
          {message || t("No upcoming consultations")}
        </Typography>
        {subtitle && (
          <Typography className={classes.emptyStateSubtext}>
            {subtitle}
          </Typography>
        )}
      </Box>
    );
  };

  const AppointmentCard = ({ appointment, isHistory = false }) => {
    const imgURL =
      appointment.patient?.user?.user_images?.at(-1)?.path_resource;
    const profileImageURL = imgURL && resizeByLink(imgURL, "upload");

    const appt_start = moment.utc(appointment?.appt_date_start);
    const appt_end = moment.utc(appointment?.appt_date_end);

    const serviceName =
      appointment.services_orders?.length > 0
        ? appointment.services_orders?.[0].service_type?.name
        : "";

    const serviceOrderStatus = lastOrderRegister(
      appointment.services_orders || []
    );
    const paymentStatus =
      serviceOrderStatus?.length > 0 ? serviceOrderStatus[0]?.status : "N/A";

    const orderId =
      serviceOrderStatus?.length > 0 ? serviceOrderStatus[0]?.id : null;

    const serviceAmount =
      appointment.services_orders?.length > 0
        ? appointment.services_orders[0].price_total
        : 0;

    const patientName = `${appointment?.patient?.firstName} ${appointment?.patient?.lastname}`;
    const isExpanded = expandedAppointment === appointment.id;
    const effectivePaymentStatus =
      serviceAmount === 0 ? "COMPLETED" : paymentStatus;

    const getStatusColor = (status) => {
      switch (status?.toLowerCase()) {
        case "completed":
          return "#4caf50";
        case "confirmed":
          return "#2196f3";
        case "pending":
          return "#ff9800";
        case "cancelled":
          return "#f44336";
        default:
          return "#9e9e9e";
      }
    };

    const getPaymentColor = (status) => {
      switch (status?.toLowerCase()) {
        case "completed":
          return "#4caf50";
        case "generated":
        case "pending":
          return "#ff9800";
        case "canceled":
          return "#f44336";
        default:
          return "#9e9e9e";
      }
    };

    const getPaymentStatusText = (status) => {
      switch (status?.toLowerCase()) {
        case "completed":
          return t("Payed");
        case "generated":
        case "pending":
          return t("Awaiting for Payment");
        case "canceled":
          return t("Cancelled");
        default:
          return status || "N/A";
      }
    };

    return (
      <Card className={classes.appointmentCard}>
        <CardContent style={{ padding: "16px" }}>
          <Box className={classes.appointmentHeader}>
            <Box className={classes.patientInfo}>
              <Avatar src={profileImageURL} className={classes.patientAvatar}>
                <PersonIcon />
              </Avatar>
              <Box className={classes.patientDetails}>
                <Typography className={classes.patientName}>
                  {patientName}
                </Typography>
                <Box className={classes.appointmentTime}>
                  <AccessTimeIcon style={{ fontSize: 16 }} />
                  {appt_start.format("MMM DD, YYYY • HH:mm")} UTC
                  {appointment?.event_type === "VIRTUAL" && (
                    <VideoCallIcon
                      style={{ fontSize: 16, marginLeft: 8, color: "#1976d2" }}
                    />
                  )}
                </Box>
              </Box>
            </Box>
            <Box className={classes.appointmentActions}>
              {!isHistory && (
                <Tooltip title={isExpanded ? "Collapse" : "Manage Appointment"}>
                  <IconButton
                    size="small"
                    onClick={() => handleExpandAppointment(appointment.id)}
                    className={`${classes.expandButton} ${
                      isExpanded ? "expanded" : ""
                    }`}
                  >
                    {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                </Tooltip>
              )}
              <IconButton size="small">
                <MoreVertIcon />
              </IconButton>
            </Box>
          </Box>

          <Box className={classes.appointmentMeta}>
            <Chip
              label={appointment?.status_appointment?.description || "Unknown"}
              className={classes.statusChip}
              style={{
                backgroundColor: `${getStatusColor(
                  appointment?.status_appointment?.description
                )}20`,
                color: getStatusColor(
                  appointment?.status_appointment?.description
                ),
              }}
              size="small"
            />

            {serviceName && (
              <Chip
                label={serviceName}
                className={classes.typeChip}
                size="small"
              />
            )}

            <Chip
              icon={<PaymentIcon style={{ fontSize: 14 }} />}
              label={getPaymentStatusText(effectivePaymentStatus)}
              className={classes.paymentChip}
              style={{
                backgroundColor: `${getPaymentColor(effectivePaymentStatus)}20`,
                color: getPaymentColor(effectivePaymentStatus),
              }}
              size="small"
            />

            {appointment?.patient?.affiliations?.[0]?.plan?.name && (
              <Chip
                label={appointment.patient.affiliations[0].plan.name}
                variant="outlined"
                size="small"
                style={{ fontSize: "0.75rem", height: 24 }}
              />
            )}
          </Box>

          {/* Appointment Reason */}
          {appointment?.appt_reason && (
            <Box className={classes.appointmentReason}>
              <Typography
                variant="body2"
                style={{ fontWeight: 600, marginBottom: 4 }}
              >
                {t("Appointment reason")}:
              </Typography>
              <Typography variant="body2">{appointment.appt_reason}</Typography>
            </Box>
          )}

          {/* Expandable Management Panel */}
          {!isHistory && (
            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
              <Box className={classes.expandablePanel}>
                {/* Action Buttons */}
                <Box className={classes.actionButtonsContainer}>
                  <Button
                    size="small"
                    startIcon={<EventAvailableIcon />}
                    className={`${classes.actionButton} ${classes.confirmButton}`}
                    onClick={() =>
                      handleChangeStatus(appointment.id, "CAPPT", patientName)
                    }
                    disabled={actionLoading}
                  >
                    {t("Confirm")}
                  </Button>

                  <Button
                    size="small"
                    startIcon={<EventBusyIcon />}
                    className={`${classes.actionButton} ${classes.cancelButton}`}
                    onClick={() =>
                      handleChangeStatus(appointment.id, "CCAPPT", patientName)
                    }
                    disabled={actionLoading}
                  >
                    {t("Cancel")}
                  </Button>

                  <Button
                    size="small"
                    startIcon={<OfflinePinIcon />}
                    className={`${classes.actionButton} ${classes.completeButton}`}
                    onClick={() =>
                      handleChangeStatus(appointment.id, "CDAPPT", patientName)
                    }
                    disabled={actionLoading}
                  >
                    {t("Concluded")}
                  </Button>

                  <Button
                    size="small"
                    startIcon={<TouchAppIcon />}
                    className={`${classes.actionButton} ${classes.reminderButton}`}
                    onClick={() =>
                      handlePaymentReminder(
                        appointment.id,
                        orderId,
                        paymentStatus
                      )
                    }
                    disabled={
                      actionLoading ||
                      paymentStatus?.toUpperCase() === "COMPLETED"
                    }
                  >
                    {t("Payment Reminder")}
                  </Button>

                  {/* Join Virtual Appointment Button */}
                  {canJoinVirtualAppointmentLocal(
                    appointment,
                    paymentStatus
                  ) && (
                    <Button
                      size="small"
                      startIcon={<VideoCallIcon />}
                      className={`${classes.actionButton}`}
                      onClick={() => handleJoinVirtualAppointment(appointment)}
                      disabled={actionLoading}
                      style={{
                        backgroundColor: "#4caf50",
                        color: "white",
                        "&:hover": {
                          backgroundColor: "#45a049",
                        },
                      }}
                    >
                      {t("Join Virtual Appointment")}
                    </Button>
                  )}
                </Box>

                {/* Price Update Form */}
                <Box className={classes.formSection}>
                  <Typography variant="subtitle2" gutterBottom>
                    {t("Modify Appointment")}
                  </Typography>
                  <Box className={classes.formRow}>
                    <TextField
                      size="small"
                      label={t("Price") + " ($)"}
                      variant="outlined"
                      value={newPrice}
                      onChange={(e) => setNewPrice(e.target.value)}
                      disabled={
                        paymentStatus?.toUpperCase() === "COMPLETED" ||
                        actionLoading
                      }
                      style={{ minWidth: 120 }}
                    />
                    <Button
                      size="small"
                      variant="contained"
                      color="primary"
                      startIcon={<CheckCircleOutlineIcon />}
                      onClick={() => handleUpdatePrice(appointment.id, orderId)}
                      disabled={
                        !newPrice ||
                        paymentStatus?.toUpperCase() === "COMPLETED" ||
                        actionLoading
                      }
                      className={classes.actionButton}
                    >
                      {t("Save")}
                    </Button>
                  </Box>

                  {/* Reschedule Form */}
                  <Box className={classes.formRow}>
                    <TextField
                      size="small"
                      label={t("Re-scheduled date")}
                      type="datetime-local"
                      variant="outlined"
                      value={rescheduleDate}
                      onChange={(e) => setRescheduleDate(e.target.value)}
                      disabled={actionLoading}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        min: moment().format("YYYY-MM-DDTHH:mm"),
                      }}
                      style={{ minWidth: 200 }}
                    />
                    <Button
                      size="small"
                      variant="contained"
                      color="secondary"
                      startIcon={<EditIcon />}
                      onClick={() =>
                        handleReschedule(appointment.id, appointment)
                      }
                      disabled={!rescheduleDate || actionLoading}
                      className={classes.actionButton}
                    >
                      {t("re-schedule")}
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Collapse>
          )}
        </CardContent>
      </Card>
    );
  };

  const StatCard = ({ icon, value, label, color, progress }) => (
    <Card className={classes.statCard}>
      <CardContent className={classes.statContent}>
        <Box className={classes.statIcon} style={{ backgroundColor: color }}>
          {icon}
        </Box>
        <Box className={classes.statInfo}>
          <Typography className={classes.statValue}>
            {loadingStats ? "..." : value}
          </Typography>
          <Typography className={classes.statLabel}>{label}</Typography>
          {progress !== undefined && (
            <Box className={classes.progressContainer}>
              <Box
                style={{
                  width: "100%",
                  height: 4,
                  backgroundColor: `${color}20`,
                  borderRadius: 2,
                  overflow: "hidden",
                }}
              >
                <Box
                  style={{
                    width: `${progress}%`,
                    height: "100%",
                    backgroundColor: color,
                    borderRadius: 2,
                    transition: "width 0.3s ease",
                  }}
                />
              </Box>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );

  const lastOrderRegister = (serviceOrders) => {
    if (serviceOrders.length > 0) {
      return serviceOrders.sort((a, b) => b?.id - a?.id);
    }
    return serviceOrders;
  };

  return (
    <DashboardMUI
      sectionTitle={t("Your Highlights")}
      description={t(
        "Here you can find a list of Next appointments and your highlights"
      )}
      icon={lineChart}
    >
      <Container maxWidth="xl" className={classes.root}>
        {/* Statistics Cards */}
        <Grid container spacing={3} className={classes.statsGrid}>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              icon={<PeopleIcon />}
              value={providerStats.totalPatients}
              label={t("Total Patients")}
              color="#4caf50"
              progress={Math.min(
                (providerStats.totalPatients / 100) * 100,
                100
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              icon={<EventIcon />}
              value={providerStats.totalAppointments}
              label={t("Total Appointments")}
              color="#2196f3"
              progress={Math.min(
                (providerStats.totalAppointments / 50) * 100,
                100
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              icon={<AttachMoneyIcon />}
              value={`$${providerStats.totalIncome.toFixed(2)}`}
              label={t("Total Income")}
              color="#ff9800"
              progress={Math.min((providerStats.totalIncome / 1000) * 100, 100)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              icon={
                <Box className={classes.ratingContainer}>
                  <StarIcon style={{ fontSize: 20 }} />
                  <Typography
                    variant="body2"
                    style={{ color: "white", fontWeight: 600 }}
                  >
                    {providerStats.averageRating}/5
                  </Typography>
                </Box>
              }
              value={providerStats.averageRating}
              label={t("Your rating")}
              color="#f44336"
              progress={(providerStats.averageRating / 5) * 100}
            />
          </Grid>
        </Grid>

        {/* Main Content */}
        <Grid container spacing={3}>
          {/* Upcoming Appointments */}
          <Grid item xs={12} lg={6}>
            <Card className={classes.sectionCard}>
              <Box className={classes.sectionHeaderEnhanced}>
                <Box style={{ display: "flex", alignItems: "center" }}>
                  <Typography
                    variant="h6"
                    className={classes.sectionTitleEnhanced}
                  >
                    <ScheduleIcon color="primary" />
                    {t("Upcoming Appointments")}
                    {appointments?.length > 0 && (
                      <span className={classes.sectionCount}>
                        {appointments.length}
                      </span>
                    )}
                  </Typography>
                </Box>
                <Tooltip title="View all appointments">
                  <IconButton size="small">
                    <MoreVertIcon />
                  </IconButton>
                </Tooltip>
              </Box>
              <Box className={classes.sectionContent}>
                {loadingData && <Loading color="#3788d8d4" />}
                {appointments?.length > 0
                  ? appointments?.map((item) => (
                      <AppointmentCard key={item?.id} appointment={item} />
                    ))
                  : !loadingData && (
                      <NoData
                        message={t("No upcoming consultations")}
                        icon={
                          <ScheduleIcon className={classes.emptyStateIcon} />
                        }
                      />
                    )}
              </Box>
            </Card>
          </Grid>

          {/* Booking History */}
          <Grid item xs={12} lg={6}>
            <Card className={classes.sectionCard}>
              <Box className={classes.sectionHeaderEnhanced}>
                <Box style={{ display: "flex", alignItems: "center" }}>
                  <Typography
                    variant="h6"
                    className={classes.sectionTitleEnhanced}
                  >
                    <CheckCircleIcon color="primary" />
                    {t("Booking History")}
                    {bookingHistory?.length > 0 && (
                      <span className={classes.sectionCount}>
                        {bookingHistory.length}
                      </span>
                    )}
                  </Typography>
                </Box>
                <Tooltip title="View all history">
                  <IconButton size="small">
                    <MoreVertIcon />
                  </IconButton>
                </Tooltip>
              </Box>
              <Box className={classes.sectionContent}>
                {loadingData && <Loading color="#3788d8d4" />}
                {bookingHistory?.length > 0
                  ? bookingHistory?.map((item) => (
                      <AppointmentCard
                        key={item?.id}
                        appointment={item}
                        isHistory
                      />
                    ))
                  : !loadingData && (
                      <NoData
                        message={t("Booking History")}
                        icon={
                          <CheckCircleIcon className={classes.emptyStateIcon} />
                        }
                      />
                    )}
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </DashboardMUI>
  );
}

export default MainProviders;
